/**
 * PATH: packages/kanban-host/src/auth/useApiAuth.ts
 * FILE_ID: KANBANHOST-PUBLIC-USE-API-AUTH-001
 * PURPOSE: Public subpath re-export of the kanban-host useApiAuth DI
 *          seam. Tenants import `setKanbanUseApiAuth` from
 *          `@quotech/kanban-host/auth/useApiAuth` at boot.
 * WHY:     Internal shim lives in `_internal/auth/` so it stays
 *          package-private from a logical-API perspective; this file
 *          is the *intentional* public re-export integrators consume.
 *          Splitting them lets us evolve the internal seam (signature,
 *          error messages, etc.) without churning every tenant boot.
 * RELATED:
 *   - packages/kanban-host/src/_internal/auth/useApiAuth.ts: canonical body.
 *   - apps/<tenant>/src/main.tsx: registers the tenant's useApiAuth.
 * NOTES FOR FUTURE AI: Importing this file also installs the All Kanban
 *   tab and the settings API provider. Gear Settings default boards
 *   must not wait for SettingsHome / a board route.
 */

import {
  installAllKanbanSettingsTab,
  registerKanbanSettingsApiProvider,
} from '@quotech/ui/kanban/install-all-kanban-settings'
import { getSamKanbanApi } from '../api'

installAllKanbanSettingsTab()
registerKanbanSettingsApiProvider(getSamKanbanApi)

export * from '../_internal/auth/useApiAuth'
